module.exports = "pegasus_template/assets/icn_4.png";